module.exports = __webpack_public_path__ + "img/titleAtive2.d65779a.png";